// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".franchise-wrap[data-v-fdc5a522]{margin-top:72px}@media (min-width:768px){.franchise-wrap[data-v-fdc5a522]{margin-top:96px}}", ""]);
// Exports
module.exports = exports;
